/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateEvaFoamDto } from '../../models/create-eva-foam-dto';
import { EvaFoam } from '../../models/eva-foam';

export interface CreateOneBaseMgmtEvaFoamControllerEvaFoam$Params {
      body: CreateEvaFoamDto
}

export function createOneBaseMgmtEvaFoamControllerEvaFoam(http: HttpClient, rootUrl: string, params: CreateOneBaseMgmtEvaFoamControllerEvaFoam$Params, context?: HttpContext): Observable<StrictHttpResponse<EvaFoam>> {
  const rb = new RequestBuilder(rootUrl, createOneBaseMgmtEvaFoamControllerEvaFoam.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EvaFoam>;
    })
  );
}

createOneBaseMgmtEvaFoamControllerEvaFoam.PATH = '/api/mgmt/eva-foam';
